import { useCallback, useState } from "react";
import axios from "../../../lib/axios";

function useForgetPassword() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const request = useCallback(async (email) => {
    setLoading(true);
    setError(false);
    setSuccess(false);
    try {
      const response = await axios.post("api/account/forgot-pw", {
        email: email,
      });

      const data = response.data;

      console.log(data);
      setSuccess(data.message);
    } catch (error) {
      console.log(error.response);
      setError(error.response.data.message);
      // return error.response.data.errors;
    } finally {
      setLoading(false);
    }
  }, []);
  return [request, loading, error, success];
}

export default useForgetPassword;
